import { useGetCompany } from "@/entities/get-company/fetch";
import { useGetNotifications } from "@/entities/get-notifications/fetch";
import { useAuth } from "@/shared/auth/fetch/useAuth";
import { useLocation, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import type { TheSidebarProps } from "../model";

export const useTheSidebarProps = (): TheSidebarProps => {
  const auth = useAuth();

  const companyId = auth.session.isAuthenticated
    ? auth.session.user.companyId
    : 0;

  const getCompany = useGetCompany(
    {
      id: companyId,
    },
    {
      enabled: auth.session.isAuthenticated,
    },
  );
  const companyData = getCompany.data;
  const isShipper = !!companyData?.data.category?.find(
    (cat) => cat === "shipper",
  );
  const isCarrier = !!companyData?.data.category?.find(
    (cat) => cat === "carrier",
  );

  const currentPath = useLocation().pathname;

  const notificationBadgeNumber = getUnreadNotificationCount();

  const navigate = useNavigate();

  const logout = useCallback(() => {
    auth.logout();
    navigate({ to: "/login" });
  }, [auth.logout, navigate]);

  return {
    isShipper,
    isCarrier,
    isSystemAdmin: auth.isSystemAdmin,
    isXmileSystemAdmin: auth.isXmileSystemAdmin,
    companyId,
    currentPath,
    notificationBadgeNumber,
    logout,
  };
};

/**
 * 未読のお知らせの数を取得する
 */
const getUnreadNotificationCount = () => {
  const notifications = useGetNotifications({
    isRead: false,
  });

  // 1以上の時のみ数字として渡す(0は表示したくないのでundefinedにする
  return notifications.data?.data.totalCount || undefined;
};
